Ext.define('SA.view.plugin.Arrow', {
    alias: 'plugin.sa-arrow',
    extend: 'Ext.AbstractPlugin',
    pluginId: 'sa-arrow',

    bias: 0.5,

    init() {
        this.cmp.on({
            resize: this.addIdleEvent,
            show: this.addIdleEvent,

            scope: this
        });

        this.cmp.addCls('sa-arrow-ct');

        this.addIdleEvent();

        this.onScroll = Ext.Function.createThrottled(this.onScroll, 20, this);

        window.addEventListener('scroll', this.onScroll, true);
    },

    addIdleEvent() {
        Ext.EventManager.idleEvent.removeListener(this.onIdleEvent, this);
        Ext.EventManager.idleEvent.addListener(this.onIdleEvent, this);
    },


    destroy() {
        window.removeEventListener('scroll', this.onScroll, true);
    },

    getTargetEl() {
        var target = this.target;

        if (!target) {
            target = this.cmp.up();
        }

        if (target && target.isComponent) {
            target = target.el;
        }

        if (target && target.dom) {
            target = target.dom;
        }

        return target;
    },

    onIdleEvent() {
        Ext.EventManager.idleEvent.removeListener(this.onIdleEvent, this);

        this.refresh();
    },

    onScroll() {
        this.refresh();
    },

    refresh() {
        var cmp = this.cmp,
            el = cmp.el,
            dom = el && el.dom,
            shadowEl = this.shadowEl,
            arrowEl = this.arrowEl,
            target, targetBounds, elBounds, alignment, arrowX, arrowY, arrowSize;

        if (!el) {
            return;
        }

        if (!arrowEl) {
            shadowEl = this.shadowEl = document.createElement('div');
            shadowEl.className = 'sa-arrow-shadow';

            arrowEl = this.arrowEl = document.createElement('div');
            arrowEl.className = 'sa-arrow-arrow';
        }

        if (this.cmp.isHidden()) {
            return;
        }

        target = this.getTargetEl();

        if (!target) {
            hideArrow();
            return;
        }

        targetBounds = target.getBoundingClientRect();
        elBounds = dom.getBoundingClientRect();

        if (elBounds.right <= targetBounds.left) {
            alignment = 'right';
        }
        else if (elBounds.left >= targetBounds.right) {
            alignment = 'left';
        }
        else if (elBounds.top >= targetBounds.bottom) {
            alignment = 'top';
        }
        else if (elBounds.bottom <= targetBounds.top) {
            alignment = 'bottom';
        }

        cmp.removeCls(['sa-arrow-align-top', 'sa-arrow-align-bottom', 'sa-arrow-align-left', 'sa-arrow-align-right']);
        cmp.addCls('sa-arrow-align-' + alignment);

        Ext.fly(arrowEl).setStyle('display', null);
        Ext.fly(shadowEl).setStyle('display', null);

        dom.appendChild(shadowEl);
        dom.appendChild(arrowEl);

        switch (alignment) {
            case 'left':
            case 'right':
                arrowSize = Ext.fly(arrowEl).getHeight();
                arrowY = Math.round(targetBounds.top - elBounds.top + (targetBounds.height - arrowSize) * this.bias);

                if (arrowY < 3 || arrowY > elBounds.height - 3 - arrowSize) {
                    arrowY = null;
                }
            break;

            case 'bottom':
            case 'top':
                arrowSize = Ext.fly(arrowEl).getWidth();
                arrowX = Math.round(targetBounds.left - elBounds.left + (targetBounds.width - arrowSize) * this.bias);

                if (arrowX < 3 || arrowX > elBounds.width - 3 - arrowSize) {
                    arrowX = null;
                }


            break;
        }

        if (arrowX || arrowY) {
            Ext.fly(arrowEl).setStyle({
                left: units(arrowX),
                top: units(arrowY)
            });

            Ext.fly(shadowEl).setStyle({
                left: units(arrowX),
                top: units(arrowY)
            });
        }
        else {
            hideArrow();
        }

        function hideArrow() {
            Ext.fly(arrowEl).setStyle('display', 'none');
            Ext.fly(shadowEl).setStyle('display', 'none');
        }

        function units(size) {
            return typeof size === 'number' ? (size + 'px') : size;
        }
    },

    setTarget(target) {
        this.target = target;

        this.refresh();
    }
});
